module.exports = __webpack_public_path__ + "img/Sample_Certificate_CSB.f1b6a46a.png";